module.exports = __webpack_public_path__ + "static/media/text_box5.b35f62da.png";